import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/google-auth/disconnect`;

type DisconnectGoogleDriveResponse = { status: boolean };

type DisconnectGoogleDriveDTO = {
  projectId: number;
  userId: string | number;
};

export const disconnectGoogleDrive = ({
  projectId,
  userId,
}: DisconnectGoogleDriveDTO): Promise<DisconnectGoogleDriveResponse> => {
  const URL = generateRoutePath(url, { projectId });
  return axios.post(URL, { projectId, userId }, { showError: false });
};

type UseDisconnectGoogleDriveOptions = {
  config?: MutationConfig<typeof disconnectGoogleDrive>;
};

export const useDisconnectGoogleDrive = ({ config }: UseDisconnectGoogleDriveOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (props) => disconnectGoogleDrive(props),
  });
};
